import Component from '../abstracts/Component';
import select2 from "select2";

export default class FooterComponent extends Component {
    get SELECTORS() {
        return {
            countriesSelect: '#countries-select'
        }
    }

    constructor(htmlEl) {
        super(htmlEl);
    }

    initSelect() {
        const options = {
            width: 'resolve',
            minimumResultsForSearch: -1,
            containerCssClass: 'custom-dt-container',
            dropdownCssClass: 'custom-dt-dropdown countries-select-dropdown',
            dropdownParent: document.querySelector('.footer__copyright-bar__lang-select'),
            dropdownAutoWidth: true
        }
        $(this.SELECTORS.countriesSelect).select2(options);

        $(this.SELECTORS.countriesSelect).on('select2:select', (e) => {
            const url = e.params.data.id;
            const lang = e.params.data.element.dataset.lang;
            console.log({url}, {lang});

            this.buildForm(url, lang).submit();
            // window.location.href = url;
        })
    }

    buildForm(url, lang) {
        const form = document.createElement('form');
        const input = document.createElement('input');

        form.classList.add('d-none');
        form.setAttribute('method', 'post');
        form.setAttribute('action', url);

        input.setAttribute('type', 'text');
        input.setAttribute('name', 'lang');
        input.setAttribute('value', lang);

        form.appendChild(input);
        document.body.appendChild(form);

        return form;
    }

    render() {
        super.render();
        console.log('Rendering FooterComponent');

        this.initSelect();
    }
}